/* global axios */

import ApiClient from './ApiClient';

class Agents extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  enable(id) {
    return axios.post(`${this.url}/${id}/enable`);
  }

  disable(id) {
    return axios.post(`${this.url}/${id}/disable`);
  }

  bulkInvite({ emails }) {
    return axios.post(`${this.url}/bulk_create`, {
      emails,
    });
  }
}

export default new Agents();
